import { render, staticRenderFns } from "./Notificacion.vue?vue&type=template&id=ba3c62a8"
import script from "./Notificacion.vue?vue&type=script&lang=js"
export * from "./Notificacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports